import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss']
})
export class PhotoComponent implements OnInit {
  
  @Output()
  imagenB64: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  view:string

  name:string

  previsualizacion: String;

  constructor() { }

  ngOnInit() {
  }

  onChange1($event: any): any {
    /*Obtengo el archivo file*/
    const file = $event.target.files[0];
     // Check file type
     const allowedTypes = ['image/png', 'image/jpeg', 'image/gif'];
     if (!allowedTypes.includes(file.type)) {
       alert('Tipo de archivo no válido. Sólo se permiten imágenes PNG, JPEG y GIF.');
       return;
     }
 
     // Check file size
     if (file.size > 5242880) {
       alert('El tamaño del archivo excede el límite. El tamaño máximo permitido es 5 MB.');
       return;
     }
     this.name=file.name
     this.extraerBase64(file).then((imagen: any) => {
      this.previsualizacion = imagen.base;
      this.imagenB64.emit(this.previsualizacion)
     });
  }

  extraerBase64 = async ($event: any) =>
    new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.readAsDataURL($event);
        reader.onload = () => {
          resolve({ base: reader.result });
        };
        reader.onerror = (error) => {
          resolve({ base: null });
        };
      } catch (error) {
        return null;
      }
    });
}
